import { EM_DASH } from "@/editor-core/labels"

// The label/value header block every printable document shares (material
// schedule, worksheet, bid sheet). Extracted in M9 — it was duplicated
// verbatim across Schedule.tsx and Worksheet.tsx.

export type HeaderPair = [string, string | null]

export function HeaderColumn({ pairs }: { pairs: HeaderPair[] }) {
  return (
    <dl className="grid grid-cols-[9.5rem_1fr] gap-x-3 gap-y-1 text-sm">
      {pairs.map(([label, value]) => (
        <div key={label} className="contents">
          <dt className="text-ink-muted">{label}</dt>
          {/* A blank prints as a visible gap on purpose — better than a
              confident wrong answer somebody acts on at the gate. */}
          <dd className="text-ink-display">{value?.trim() || EM_DASH}</dd>
        </div>
      ))}
    </dl>
  )
}
